import { useEffect } from 'react'

import { useFetch } from '@reveni-io/reveni-ui'

import returnsServices from '@/returns/services/services'

const useDeliveryMethods = ({ returnId }) => {
  const { data, loading, fetchData } = useFetch(returnsServices.getDeliveryMethods, {
    doInitialRequest: false,
  })

  useEffect(() => {
    if (returnId) {
      fetchData({ returnId })
    }
  }, [fetchData, returnId])

  return { deliveryMethods: data, loading }
}

export default useDeliveryMethods
